import { render, staticRenderFns } from "./AlphaCognize.vue?vue&type=template&id=7a479e0e&scoped=true"
import script from "./AlphaCognize.vue?vue&type=script&lang=js"
export * from "./AlphaCognize.vue?vue&type=script&lang=js"
import style0 from "./AlphaCognize.vue?vue&type=style&index=0&id=7a479e0e&prod&lang=css"
import style1 from "./AlphaCognize.vue?vue&type=style&index=1&id=7a479e0e&prod&scoped=true&lang=css"
import style2 from "../../constant/css/detail.css?vue&type=style&index=2&id=7a479e0e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a479e0e",
  null
  
)

export default component.exports